import { s4, s8 } from '@ardoq/design-tokens';

export const VIEW_LEGEND_ROW_TOP_MARGIN = s8;
export const VIEW_LEGEND_ITEM_BOTTOM_MARGIN = s4;
